export default defineNuxtRouteMiddleware((to) => {
  const origin = process.server ? useRequestURL()?.origin : window.location.origin;

  if (!origin) {
    return;
  }

  // 1. Canonical Logic (Updated for Non-Trailing Slashes)
  const path =
    to.path.length > 1 && to.path.endsWith('/') ? to.path.slice(0, -1) : to.path;
  const canonicalUrl = `${origin}${path}`;

  const headLinks = [
    {
      rel: 'canonical',
      href: canonicalUrl,
      key: 'canonical',
    },
  ];

  // 2. Pagination NoIndex Logic (New)
  const headMeta = [];
  const pageQuery = to.query.page;

  // Add noindex if page query exists and is not '1'
  if (pageQuery && pageQuery !== '1') {
    headMeta.push({
      name: 'robots',
      content: 'noindex, follow',
      key: 'robots',
    });
  }

  // 3. Apply all head changes
  useHead({
    link: headLinks,
    meta: headMeta,
  });
});
